/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IBaseSilo, IBaseSiloInterface } from "../IBaseSilo";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "enum IBaseSilo.AssetStatus",
        name: "status",
        type: "uint8",
      },
    ],
    name: "AssetStatusUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Borrow",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "collateralOnly",
        type: "bool",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shareAmountRepaid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "seizedCollateral",
        type: "uint256",
      },
    ],
    name: "Liquidate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Repay",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "collateralOnly",
        type: "bool",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetStorage",
    outputs: [
      {
        components: [
          {
            internalType: "contract IShareToken",
            name: "collateralToken",
            type: "address",
          },
          {
            internalType: "contract IShareToken",
            name: "collateralOnlyToken",
            type: "address",
          },
          {
            internalType: "contract IShareToken",
            name: "debtToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "totalDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "collateralOnlyDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalBorrowAmount",
            type: "uint256",
          },
        ],
        internalType: "struct IBaseSilo.AssetStorage",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "borrowPossible",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_depositor",
        type: "address",
      },
    ],
    name: "depositPossible",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAssets",
    outputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAssetsWithState",
    outputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
      {
        components: [
          {
            internalType: "contract IShareToken",
            name: "collateralToken",
            type: "address",
          },
          {
            internalType: "contract IShareToken",
            name: "collateralOnlyToken",
            type: "address",
          },
          {
            internalType: "contract IShareToken",
            name: "debtToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "totalDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "collateralOnlyDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalBorrowAmount",
            type: "uint256",
          },
        ],
        internalType: "struct IBaseSilo.AssetStorage[]",
        name: "assetsStorage",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "interestData",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "harvestedProtocolFees",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "protocolFees",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "interestRateTimestamp",
            type: "uint64",
          },
          {
            internalType: "enum IBaseSilo.AssetStatus",
            name: "status",
            type: "uint8",
          },
        ],
        internalType: "struct IBaseSilo.AssetInterestData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "isSolvent",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "liquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "siloRepository",
    outputs: [
      {
        internalType: "contract ISiloRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "syncBridgeAssets",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "utilizationData",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "totalDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalBorrowAmount",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "interestRateTimestamp",
            type: "uint64",
          },
        ],
        internalType: "struct IBaseSilo.UtilizationData",
        name: "data",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IBaseSilo__factory {
  static readonly abi = _abi;
  static createInterface(): IBaseSiloInterface {
    return new utils.Interface(_abi) as IBaseSiloInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IBaseSilo {
    return new Contract(address, _abi, signerOrProvider) as IBaseSilo;
  }
}
